import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { HttpService, NotificationService, TmsWebBaseEditService } from 'tms-lib';
import {
  StockItemHeader,
  StockItemHeaderAddRemove,
  StockItemHeaderForPurchaseInvoice,
  StockItemHeaderReceipt,
} from '../../../models';

@Injectable({
  providedIn: 'root',
})
export class StockItemHeaderService extends TmsWebBaseEditService<StockItemHeader, StockItemHeader> {
  public refreshDetails = new Subject<void>();

  constructor(protected httpService: HttpService, protected notificationService: NotificationService) {
    super('StockItemHeader', $localize`Stock Item Header`, httpService, notificationService);
  }

  getStockForQuickCreatePurchaseInvoice(search: string): Observable<StockItemHeaderForPurchaseInvoice[]> {
    return this.httpService.get<StockItemHeaderForPurchaseInvoice[]>(
      `${this.apiUrl}/StockForQuickCreatePurchaseInvoice?search=${search}`,
    );
  }

  getStockForPurchaseInvoice(
    supplierId: string,
    purchaseInvoiceId: string,
  ): Observable<StockItemHeaderForPurchaseInvoice[]> {
    return this.httpService.get<StockItemHeaderForPurchaseInvoice[]>(
      `${this.apiUrl}/StockForPurchaseInvoice?supplierId=${supplierId}&purchaseInvoiceId=${purchaseInvoiceId}`,
    );
  }

  getStockReceiptsPurchaseOrder(purchaseOrderLineId: string): Observable<StockItemHeaderReceipt> {
    return this.httpService.get<StockItemHeaderReceipt>(
      `${this.apiUrl}/StockReceiptsPurchaseOrder?id=${purchaseOrderLineId}`,
    );
  }

  getStockReceiptsForPurchaseOrder(purchaseOrderLineId: string): Observable<StockItemHeaderReceipt[]> {
    return this.httpService.get<StockItemHeaderReceipt[]>(
      `${this.apiUrl}/StockReceiptsForPurchaseOrder?purchaseOrderLineid=${purchaseOrderLineId}`,
    );
  }

  removeFromPurchaseInvoice(stockItemHeaderAddRemove: StockItemHeaderAddRemove): Observable<string> {
    return this.httpService.post<string>(`${this.apiUrl}/RemoveFromPurchaseInvoice`, stockItemHeaderAddRemove);
  }

  addToPurchaseInvoice(stockItemHeaderAddRemove: StockItemHeaderAddRemove): Observable<string> {
    return this.httpService.post<string>(`${this.apiUrl}/AddToPurchaseInvoice`, stockItemHeaderAddRemove);
  }

  updateInvoiceValues(stockItemHeaderAddRemove: StockItemHeaderAddRemove): Observable<string> {
    return this.httpService.post<string>(`${this.apiUrl}/UpdateInvoiceValues`, stockItemHeaderAddRemove);
  }
}
